var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('calendar',{ref:"calendar",attrs:{"mode":"date","locale":"en","color":"info","first-day-of-week":2,"is-expanded":"","show-iso-weeknumbers":"","value":_vm.metadata.range,"attributes":_vm.calendarAttributes,"min-date":_vm.minDate,"max-date":_vm.maxDate},on:{"dayclick":_vm.onCalendarDateClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }